import { render, staticRenderFns } from "./RecruitingPage.vue?vue&type=template&id=2d936529&scoped=true&lang=pug&"
import script from "./RecruitingPage.vue?vue&type=script&lang=ts&"
export * from "./RecruitingPage.vue?vue&type=script&lang=ts&"
import style0 from "./RecruitingPage.vue?vue&type=style&index=0&id=2d936529&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d936529",
  null
  
)

export default component.exports